/* eslint-disable react/require-default-props */

import React from 'react';
import Icon from 'components/DesignSystem/Icon';
import TooltipWrapper from 'components/DesignSystem/TooltipWrapper';
import { IconType } from 'components/DesignSystem/Icon/icons';

export type IconActionVariant = 'primary' | 'danger' | 'secondary';

interface IconActionButtonProps {
  icon: IconType;
  label: string;
  onClick: () => void;
  variant?: IconActionVariant;
  disabled?: boolean;
  id?: string;
}

/**
 * Botão de ação representado por ícone (lápis, lixeira, etc.), com tooltip do
 * DesignSystem. Espelha o padrão das telas admin "Sobre"/"Flux" (`btn btn-sm
 * btn-outline-*` + <Icon size="small">), centralizando-o num componente
 * reutilizável. O `label` vira o tooltip e o `aria-label` (acessibilidade).
 */
export default function IconActionButton({
  icon,
  label,
  onClick,
  variant = 'primary',
  disabled = false,
  id,
}: IconActionButtonProps) {
  return (
    <TooltipWrapper title={label}>
      <button
        type="button"
        id={id}
        className={`btn btn-sm btn-outline-${variant}`}
        onClick={onClick}
        disabled={disabled}
        aria-label={label}
      >
        <Icon iconType={icon} size="small" />
      </button>
    </TooltipWrapper>
  );
}
